import { inject, Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
@Injectable({
  providedIn: 'root'
})
export class LoadingService {
  private spinnerSvc = inject(NgxSpinnerService);
  private count = 0;

  busy() {
    this.count++;
    this.spinnerSvc.show('loading-spinner', {
      fullScreen: true,
      color: '#ccc',
      bdColor: 'rgba(51,51,51,0.8)',
      size: 'large',
      type: 'ball-scale-multiple'
    })
  }

  idle() {
    this.count--;
    if (this.count <= 0) {
      this.count = 0;
      this.spinnerSvc.hide('loading-spinner');
    }
  }

}
